var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.3,
    y: 17.7,
    width: 38.6,
    height: 40.2,
    rx: 2.5,
    stroke: "#FFFCFC",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 25.8,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 36.2,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.2,
    y: 46.6,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 25.8,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 36.2,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4,
    y: 46.6,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 25.8,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45.6,
    y: 36.2,
    width: 6.4,
    height: 6.4,
    rx: 0.8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3999 21.8C51.2836 21.8 51.9999 21.0836 51.9999 20.2C51.9999 19.3193 51.2884 18.6048 50.4089 18.6H56.8V22.6H18.4V18.6H23.991C23.1115 18.6048 22.3999 19.3193 22.3999 20.2C22.3999 21.0836 23.1163 21.8 23.9999 21.8C24.8836 21.8 25.5999 21.0836 25.5999 20.2C25.5999 19.3193 24.8884 18.6048 24.0089 18.6H50.391C49.5115 18.6048 48.7999 19.3193 48.7999 20.2C48.7999 21.0836 49.5163 21.8 50.3999 21.8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.19494907f1a92516435af6b5f861b1ab.svg";
export { ForwardRef as ReactComponent };